"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arb = exports.Eq = exports.Iso = exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
exports.Type = prelude_1.t.fromNewtype(prelude_1.t.string, 'PostId');
exports.Iso = prelude_1.nt.iso();
exports.Eq = prelude_1.nt.getEq(prelude_1.s.Eq);
exports.Arb = prelude_1.fc.fromNewtype(prelude_1.fc.string());
//# sourceMappingURL=PostId.js.map